import { lazy } from 'react';
import type { RouteConfig } from '../types';
import { ComponentSuspense } from '@/components/ui/suspense-wrapper';

const SubscriptionsListPage = lazy(
  () => import('@/pages/app/admin/subscriptions/list')
);

const SubscriptionDetailPage = lazy(
  () => import('@/pages/app/admin/subscriptions/detail')
);

export const subscriptionRoutes: RouteConfig[] = [
  {
    path: 'admin/subscriptions',
    element: (
      <ComponentSuspense>
        <SubscriptionsListPage />
      </ComponentSuspense>
    ),
    meta: {
      title: 'Subscriptions | UzaForm',
      description: 'View and manage all subscriptions',
    },
  },
  {
    path: 'admin/subscriptions/:subscriptionId',
    element: (
      <ComponentSuspense>
        <SubscriptionDetailPage />
      </ComponentSuspense>
    ),
    meta: {
      title: 'Subscription Details | UzaForm',
      description: 'View subscription details',
    },
  },
];
